import { AccessSettings } from "../models/access.settings";
import BaseService from "./_base.service";

const endpoint = "accesses/settings";

const AccessSettingsService = {
  ...BaseService<AccessSettings>({ endpoint }),
};

export default AccessSettingsService;
